export const QCOM_LANDING_PAGE_URL =
  'https://www.qantas.com/au/en/book-a-trip/hotels-and-airbnb.html';

export const HOTELS_HOST = 'https://www.qantas.com';
export const QH_LIST_URL = `${HOTELS_HOST}/hotels/search/list`;
export const QH_DEALS_URL = `${HOTELS_HOST}/hotels/deals`;
export const QH_SELF_SERVICE_URL = `${HOTELS_HOST}/hotels/manage/bookings`;
export const QH_LUXE_URL = 'https://exclusive.hotel.qantas.com.au';
export const QH_PACKAGES_URL = 'https://www.qantas.com/holidays';
export const CONTACT_US = `${HOTELS_HOST}/hotels/contact-us`;
export const FAQS = `${HOTELS_HOST}/faqs`;
export const DESTINATIONS_AUSTRALIA = `${HOTELS_HOST}/australia`;
export const QCOM_PRIVACY_AND_SECURITY_URL =
  'https://www.qantas.com/au/en/support/privacy-and-security.html';
export const QCOM_TERMS_OF_USE_URL =
  'https://www.qantas.com/au/en/support/terms-of-use.html';
export const QFF_SIGNUP_URL = 'https://www.qantas.com/fflyer/dyns/joinff';

export const QFF_MY_ACCOUNT_URL =
  'https://www.qantas.com/au/en/frequent-flyer/my-account.html';
export const QFF_MY_PROFILE_URL =
  'https://www.qantas.com/au/en/frequent-flyer/my-account/profile.html';
export const QFF_MY_POINTS_ACTIVITY_URL =
  'https://www.qantas.com/au/en/frequent-flyer/my-account/points-activity.html';
